export const validateGtag = (): boolean => {
  if (typeof window === 'undefined' || typeof window.gtag === 'undefined') {
    console.warn('Google Analytics (gtag) is not loaded yet');
    return false;
  }

  return true;
};

export function waitForGtag(
  callback: () => void,
  maxDuration = 10000, // 10 seconds
): () => void {
  if (validateGtag()) {
    callback();
    return () => {};
  }

  const startTime = Date.now();
  let interval = 100;
  let timeoutId: ReturnType<typeof setTimeout>;

  const check = () => {
    if (validateGtag()) {
      callback();
      return;
    }

    const elapsed = Date.now() - startTime;
    if (elapsed >= maxDuration) return;

    interval = Math.min(interval * 1.5, 1000);
    timeoutId = setTimeout(check, interval);
  };

  timeoutId = setTimeout(check, interval);

  return () => clearTimeout(timeoutId);
}
